<template>
  <v-select
    :value="value"
    label="Box"
    :items="boxes"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <template #prepend>
      <v-icon color="grey lighten-1" small>mdi-package-variant-closed</v-icon>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "BoxSelect",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      boxes: [
        "",
        "A-BOX",
        "B-BOX",
        "C-BOX",
        "D-BOX",
        "E-BOX",
        "F-BOX",
        "G-BOX",
        "I-BOX",
        "L-BOX",
        "N-BOX",
        "O-BOX",
        "P-BOX",
        "Q-BOX",
        "S-BOX",
        "C3-BOX",
        "D2-BOX",
        "POPUPX2-BOX",
        "POPUP-BOX",
        "A3-BOX",
        "A4-BOX",
        "B3-BOX",
        "B4-BOX",
        "102-BOX",
        "105-BOX",
        "25X30X6-BOX",
        "30X36X6-BOX",
        "Parts Mailer Box",
        "20X20-BOX",
        "Bubble Mailer Envelope",
        "ADDON",
        "Manufacturer Box",
        "FEDEX-PAK-1",
        "FEDEX-PAK-2",
        "FEDEX-PAK-3",
      ],
    };
  },
};
</script>
